import { CircularProgress, styled } from '@mui/material';
import { forwardRef } from 'react';
import IconButton from 'shell/components/IconButton';
import Stack from 'shell/components/Stack';
import Text from 'shell/components/Text';

const RootStack = styled(Stack)(({ color, theme }) => {
    return {
        border: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        borderRadius: '4px',
        minWidth: 0,
        height: '1.625rem',
        paddingLeft: theme.spacing(1),
        ...(color === 'error' && {
            borderColor: theme.palette.ensightful.error[700],
        }),
    };
});

const CustomText = styled(Text)(({ $color, theme }) => {
    return {
        ...($color === 'error' && {
            color: theme.palette.ensightful.error[700],
        }),
    };
});

const CustomIconButton = styled(IconButton)(({ color, theme }) => {
    return {
        ...(color === 'error' && {
            color: theme.palette.ensightful.error[700],
            '&:hover': {
                color: theme.palette.ensightful.error[700],
            },
        }),
    };
});

export default forwardRef(({ color = 'default', content, disabled, loading, onClick, ...rest }, ref) => {
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick(e);
    };

    return (
        <RootStack ref={ref} {...rest} alignItems={'center'} color={color} direction={'row'} spacing={2}>
            <CustomText $color={color} noWrap variant={'p2'}>
                {content}
            </CustomText>
            {loading ? (
                <CircularProgress sx={{ width: '24px !important', height: '24px !important', p: 1 }} />
            ) : (
                <CustomIconButton
                    aria-label={'remove item'}
                    color={color}
                    disabled={disabled}
                    kind={'exit'}
                    size={'small'}
                    variant={'square'}
                    onClick={handleClick}
                />
            )}
        </RootStack>
    );
});
